export default function PhoneIcon() {
  return (
    <svg
      data-testid="phone_icon"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="6" fill="#E0F1FE" />
      <path
        d="M9 21V22.8C9 23.9201 9 24.4802 9.21799 24.908C9.40973 25.2843 9.71569 25.5903 10.092 25.782C10.5198 26 11.0799 26 12.2 26H19.8C20.9201 26 21.4802 26 21.908 25.782C22.2843 25.5903 22.5903 25.2843 22.782 24.908C23 24.4802 23 23.9201 23 22.8V9.2C23 8.07989 23 7.51984 22.782 7.09202C22.5903 6.71569 22.2843 6.40973 21.908 6.21799C21.4802 6 20.9201 6 19.8 6H12.2C11.0799 6 10.5198 6 10.092 6.21799C9.71569 6.40973 9.40973 6.71569 9.21799 7.09202C9 7.51984 9 8.0799 9 9.2V21ZM9 21H22.782M14.5 9H17.9455M16.5 23.5C16.5 23.7761 16.2761 24 16 24C15.7239 24 15.5 23.7761 15.5 23.5C15.5 23.2239 15.7239 23 16 23C16.2761 23 16.5 23.2239 16.5 23.5Z"
        stroke="#374151"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
